<template>
	<ClientOnly>
		<v-menu
			v-if="!isMobile"
			v-model="isDateMenuOpen"
			:attach="!nav"
			:close-on-content-click="false"
			scrim
			close-on-back
			:scroll-strategy="customScrollStrategy"
			:content-class="{ 'booker-date': true, 'booker-date__nav': nav }"
			:style="`z-index: 2100; --nav-offset: ${(navHeight ?? 0) + y}px`">
			<GlobalBookerDateContainer v-model="isDateMenuOpen" />
		</v-menu>
		<v-dialog
			v-else
			v-model="isDateMenuOpen"
			fullscreen
			scroll-strategy="none"
			:content-class="{ 'booker-date': true, 'booker-data__nav': nav }"
			:style="`z-index: 2100;`">
			<GlobalBookerDateContainer v-model="isDateMenuOpen"></GlobalBookerDateContainer>
		</v-dialog>
	</ClientOnly>
</template>

<script lang="ts" setup>
const isDateMenuOpen = defineModel<boolean>()
const navHeight = inject<Ref<number | undefined>>('navHeight')
const { isMobile } = useWindowWidth()

const { y } = useWindowScroll()
const initialScrollY = ref(0)

const customScrollStrategy = () => {
	initialScrollY.value = window.scrollY

	const handleScroll = () => {
		const scrolledDistance = Math.abs(window.scrollY - initialScrollY.value)
		if (scrolledDistance > 150) {
			isDateMenuOpen.value = false
		}
	}
	window.addEventListener('scroll', handleScroll)
	return () => {
		window.removeEventListener('scroll', handleScroll)
	}
}

defineProps<{
	nav?: boolean
}>()
</script>

<style lang="scss">
@import './DateMenu';
</style>
